<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="row">
        <div class="col-xs-10">
          <h1>Push Requests</h1>
        </div>
        <div class="col-xs-2">
          <router-link :to="{ name: 'AddPush' }" class="btn btn-sm btn-add">
            <i class="fa fa-plus-square"></i>Send New Push
          </router-link>
        </div>
      </div>
    </section>
    <section class="content">
      <form v-on:submit.prevent="dopagination(0)">
        <div class="row">
          <div class="col-xs-6 col-sm-2 form-group">
            <select
              title=""
              name="app_id"
              id="app_id"
              class="form-control input-sm select2"
              @change="dopagination(0)"
              v-model="app_id"
              v-select="app_id"
            >
              <option value="">-- Select App --</option>
              <option
                v-for="(data, index) in appArr"
                :key="index"
                :value="data.id"
              >
                {{ data.app_name }}
              </option>
            </select>
          </div>

          <div class="col-xs-6 col-sm-2 form-group">
            <select
              title=""
              name="id_reseller"
              id="id_reseller"
              class="form-control input-sm select2"
              @change="dopagination(0)"
              v-model="id_reseller"
              v-select="id_reseller"
            >
              <option value="">-- Select Reseller --</option>
              <option
                v-for="(data, index) in resellerArr"
                :key="index"
                :value="index"
              >
                {{ data }}
              </option>
            </select>
          </div>

          <div class="col-xs-6 col-sm-2 form-group">
            <select
              title=""
              name="status"
              id="status"
              class="form-control input-sm select2"
              @change="dopagination(0)"
              v-model="status"
              v-select="status"
            >
              <option value="">-- Select Status--</option>
              <option value="0">Pending</option>
              <option value="1">Approved and Sent</option>
              <option value="2">Rejected</option>
            </select>
          </div>

          <div class="col-xs-6 col-sm-1 form-group" style="margin-bottom: 0">
            <select
              title=""
              name="limit"
              id="limit"
              class="form-control input-sm select2"
              @change="dopagination(0)"
              v-model="display_limit"
              v-select="display_limit"
            >
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="75">75</option>
              <option value="100" selected>100</option>
            </select>
          </div>
          <div class="col-xs-6 col-sm-1 ZRP form-group btnLeft">
            <button
              class="btn btn-sm btn-submit"
              id="apply"
              @click="dopagination(0)"
            >
              <i class="fa fa-search"></i> Search
            </button>
          </div>
        </div>
      </form>
      <div class="row">
        <div class="col-sm-12">
          <div class="alert alert-info" v-if="alert_message">
            {{ alert_message }}
          </div>
        </div>
        <div class="col-md-12">
          <div class="box" id="pagination">
            <div class="box-header">
              <h3 class="box-title">
                Total : {{ totalData }} Showing {{ dispplayFrom }} to
                {{ dispplayTo }}
              </h3>
            </div>
            <div class="box-body">
              <div class="table-responsive">
                <table
                  class="table table-0024 table-bordered table-striped table-scroll"
                >
                  <thead>
                    <tr>
                      <th class="tdCenter tdSN">SN</th>
                      <th class="tdCenter">App Name</th>
                      <th class="tdCenter">Push Title</th>
                      <th class="tdCenter">Push Message</th>
                      <th class="tdCenter">Push Type</th>
                      <th class="tdCenter">Status</th>
                      <th class="tdCenter">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(data, index) in dataCollections" :key="data.id">
                      <td class="tdCenter tdSN">
                        {{ parseInt(sl) + parseInt(index) }}
                      </td>
                      <td class="tdCenter">
                        {{ data.app_name }}
                      </td>
                      <td class="tdCenter">
                        {{ data.headings }}
                      </td>
                      <td class="tdCenter">
                        {{ data.push_message }}
                      </td>
                      <td class="tdCenter">
                        {{ data.pin_type }}
                      </td>
                      <td class="tdCenter">
                        <span
                          class="label label-warning"
                          v-if="data.push_status == 0"
                          >Pending</span
                        >
                        <span
                          class="label label-success"
                          v-if="data.push_status == 1"
                          >Approved and Sent</span
                        >
                        <span
                          class="label label-danger"
                          v-if="data.push_status == 2"
                          >Rejected</span
                        >
                        <span
                          class="label label-primary"
                          v-if="data.push_status == 3"
                          >Draft</span
                        >
                      </td>
                      <td class="tdCenter">
                        <a
                          title="Approve and Send"
                          @click="pushApproval(data, 1)"
                          class="btn btn-sm btn-success btn-sm2"
                          style="padding: 1px 2px"
                          :disabled="data.push_status != 0"
                        >
                          <i class="fa fa-check"> </i> Approve
                        </a>
                        &nbsp;
                        <a
                          title="Reject"
                          @click="pushApproval(data, 2)"
                          class="btn btn-sm btn-danger btn-sm2"
                          style="padding: 1px 2px"
                          :disabled="data.push_status != 0"
                        >
                          <i class="fa fa-close"> </i> Reject
                        </a>
                      </td>
                    </tr>
                    <tr v-if="dataCollections.length == 0">
                      <td colspan="13" class="tdCenter" style="padding: 30px 0">
                        <b>No Records Found</b>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="pagination" v-if="last_page > 1">
                <a
                  v-if="prev_page_url"
                  href="#"
                  @click="dopagination(prevPage)"
                  class="next"
                >
                  « Previous
                </a>
                <span v-else class="disabled">« Previous</span>
                <span v-if="last_page > max_display_pagination">
                  <span v-for="index in last_page">
                    <span v-if="index == 1 || index == 2">
                      <span class="current" v-if="index == current_page">
                        {{ index }}
                      </span>
                      <span v-else>
                        <a href="#" @click="dopagination(index)">
                          {{ index }}
                        </a>
                      </span>
                      <span v-if="index == 2 && firstDotted">..</span>
                    </span>
                    <span v-if="randomPageNumber.includes(index)">
                      <span class="current" v-if="index == current_page">
                        {{ index }}
                      </span>
                      <span v-else>
                        <a href="#" @click="dopagination(index)">
                          {{ index }}
                        </a>
                      </span>
                    </span>
                    <span v-if="index == last_page || index == last_page - 1">
                      <span v-if="index == last_page - 1 && lastDotted">
                        ..
                      </span>
                      <span class="current" v-if="index == current_page">
                        {{ index }}
                      </span>
                      <span v-else>
                        <a href="#" @click="dopagination(index)">
                          {{ index }}
                        </a>
                      </span>
                    </span>
                  </span>
                </span>
                <span v-else>
                  <span v-for="index in last_page">
                    <span class="current" v-if="index == current_page">
                      {{ index }}
                    </span>
                    <span v-else>
                      <a href="#" @click="dopagination(index)">{{ index }}</a>
                    </span>
                  </span>
                </span>
                <a
                  v-if="next_page_url"
                  href="#"
                  @click="dopagination(nextPage)"
                  class="next"
                >
                  Next »
                </a>
                <span v-else class="disabled">Next »</span>
              </div>
            </div>
            <div class="box-footer"></div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import axios from "axios";

export default {
  name: "PushLists",
  data() {
    return {
      dataCollections: [],
      appArr: [],
      resellerArr: [],
      app_id: "",
      id_reseller: "",
      status: "",
      sl: 1,
      display_limit: 100,
      alert_message: "",
      totalData: 0,
      dispplayTo: 0,
      dispplayFrom: 0,

      // Pagination Variables
      prev_page_url: false,
      next_page_url: false,
      last_page: 1,
      current_page: null,
      max_display_pagination: 9,
      randomPageNumber: {},
      firstDotted: false,
      lastDotted: false,
      prevPage: "",
      nextPage: "",
    };
  },
  created() {
    let rootObject = this;
    axios
      .get("get-app-dropdown-data")
      .then(function (response) {
        //console.log(response.data.data);
        rootObject.appArr = response.data;
        loader.hide();
      })
      .catch(function (error) {
        let alertmessage = "";
        for (var prop in error.response.data) {
          alertmessage += " " + error.response.data[prop];
        }
        //console.log(alertmessage);
        rootObject.alert_message = alertmessage;
        loader.hide();
        rootObject.com_errorHandel(error);
      });

    axios
      .get("get-reseller-dropdown-data")
      .then(function (response) {
        rootObject.resellerArr = response.data.data;
        //console.log(rootObject.resellerArr);
        loader.hide();
      })
      .catch(function (error) {
        let alertmessage = "";
        for (var prop in error.response.data) {
          alertmessage += " " + error.response.data[prop];
        }
        //console.log(alertmessage);
        rootObject.alert_message = alertmessage;
        loader.hide();
        rootObject.com_errorHandel(error);
      });

    this.dopagination(0);
  },
  methods: {
    pushApproval(data, status) {
      if (data.push_status != 0) {
        return 0;
      }
      var rootObject = this;
      let msg = "";
      if (status == 1) {
        msg = "Do you really want to Approve and Send push now ?";
      } else {
        msg = "Do you really want to Reject and Send push now ?";
      }

      const form = new FormData();
      form.append("id", data.id);
      form.append("push_status", status);

      var config = {
        headers: { "Content-Type": "multipart/form-data" },
      };

      $.confirm({
        title: "Confirm!",
        content: msg,
        buttons: {
          yes: function () {
            axios
              .post("push-approval", form, config)
              .then((response) => {
                rootObject.alert_message = response.data.message;
                setTimeout(function () {
                  rootObject.alert_message = "";
                }, 3000);
                rootObject.dopagination(0);
              })
              .catch((error) => console.error(error));
          },
          no: function () {
            //return;
          },
        },
      });
    },

    dopagination(page_no = "") {
      loader.show();
      var rootObject = this;
      let querystr =
        "app_id=" +
        this.app_id +
        "&status=" +
        this.status +
        "&id_reseller=" +
        this.id_reseller;
      if (page_no > 0) {
        querystr += "&page=" + page_no;
      }
      //console.log(querystr);

      axios
        .get("push?" + querystr)
        .then(function (response) {
          //console.log(response);
          rootObject.populateData(response);
        })
        .catch(function (error) {
          console.log(error);
          let alertmessage = "";
          for (var prop in error.response.data) {
            alertmessage += " " + error.response.data[prop];
          }
          console.log(alertmessage);
          loader.hide();
          rootObject.com_errorHandel(error);
        });
    },

    populateData(response) {
      var responseData = response.data;
      //console.log(responseData.data);
      this.sl = parseInt(responseData.from);
      this.dataCollections = responseData.data;
      this.totalData = responseData.total;
      this.dispplayFrom = responseData.from;
      this.dispplayTo = responseData.to;
      this.display_limit = responseData.per_page;
      this.paginationGenerate(responseData);
      loader.hide();
    },

    paginationGenerate(response) {
      this.prev_page_url = response.prev_page_url;
      this.next_page_url = response.next_page_url;
      this.last_page = response.last_page;
      this.current_page = response.current_page;
      this.randomPageNumber = [];
      this.firstDotted = false;
      this.lastDotted = false;
      this.prevPage = this.current_page - 1;
      this.nextPage = this.current_page + 1;
      let countableOtherPages = this.max_display_pagination - 4;
      if (this.current_page == 1 || this.current_page == 2) {
        for (let i = 3; i <= 3 + (countableOtherPages - 1); i++) {
          this.randomPageNumber.push(i);
        }
        this.lastDotted = true;
      } else if (
        this.current_page == this.last_page ||
        this.current_page == this.last_page - 1
      ) {
        let endPage = this.last_page - 2;
        for (let i = endPage; i >= endPage - (countableOtherPages - 1); i--) {
          this.randomPageNumber.push(i);
        }
        this.firstDotted = true;
      } else {
        let interval = parseInt(countableOtherPages / 2);
        if (this.current_page <= interval + 3) {
          for (let i = 3; i <= 3 + (countableOtherPages - 1); i++) {
            this.randomPageNumber.push(i);
          }
          this.lastDotted = true;
        } else if (this.current_page >= this.last_page - (interval + 2)) {
          let endPage = this.last_page - 2;
          for (let i = endPage; i >= endPage - (countableOtherPages - 1); i--) {
            this.randomPageNumber.push(i);
          }
          this.firstDotted = true;
        } else {
          for (
            let i = this.current_page;
            i <= this.current_page + interval;
            i++
          ) {
            this.randomPageNumber.push(i);
          }

          for (
            let i = this.current_page - 1;
            i >= this.current_page - interval;
            i--
          ) {
            this.randomPageNumber.push(i);
          }
        }
      }
      //console.log(this.randomPageNumber);
    },
  },
  mounted: function () {
    $(".select2").select2();
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.red {
  color: red;
}
</style>
